import { AppState } from 'Store'
import { createSelector } from 'reselect'

const currentChat = (state: AppState) => state.chat.chat.currentChat ?? null
const messages = (state: AppState) => state.chat.chat.messages ?? []
const totalMessages = (state: AppState) => state.chat.chat.totalMessages
const params = (state: AppState) => state.chat.chat.params
const isLoading = (state: AppState) => state.chat.chat.isLoading
const isReaded = (state: AppState) => state.chat.chat.isReaded
const serviceMessage = (state: AppState) => state.chat.chat.serviceMessage
const ticketScoreId = (state: AppState) => state.chat.chat.ticketScoreId
const viewRating = (state: AppState) => state.chat.chat.viewRating
const chatFiles = (state: AppState) => state.chat.chat.chatFiles ?? []
const filesInProgress = (state: AppState) => state.chat.chat.filesInProgress ?? []
const foundMessages = (state: AppState) => state.chat.chat.foundMessages
const currentFoundMessage = (state: AppState) => state.chat.chat.currentFoundMessage
const selectAwaitedFiles = (state: AppState) => state.chat.chat.awaitedFileNames
const selectChatSettings = (state: AppState) => state.chat.chat.chatSettings
const selectChatToken = (state: AppState) => state.chat.chat.chatToken
const selectChatAvailableUrl = createSelector(selectChatSettings, (settings) => {
	return settings?.data?.chat_visible?.map((setting) => setting.url)
})
const currentQuote = (state: AppState) => state.chat.chat.currentQuote
const foundQuoteMessage = (state: AppState) => state.chat.chat.foundQuoteMessage
const writingTimeoutIds = (state: AppState) => state.chat.chat.writingTimeoutIds

export const chatSelectors = {
	currentChat,
	messages,
	totalMessages,
	params,
	isLoading,
	isReaded,
	serviceMessage,
	ticketScoreId,
	viewRating,
	chatFiles,
	filesInProgress,
	foundMessages,
	currentFoundMessage,
	selectAwaitedFiles,
	selectChatSettings,
	selectChatToken,
	selectChatAvailableUrl,
	currentQuote,
	foundQuoteMessage,
	writingTimeoutIds,
}
